import { render } from "./NewPassword.vue?vue&type=template&id=b65dff06&scoped=true"
import script from "./NewPassword.vue?vue&type=script&lang=js"
export * from "./NewPassword.vue?vue&type=script&lang=js"

import "./NewPassword.vue?vue&type=style&index=0&id=b65dff06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65dff06"]])

export default __exports__